import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-customInfo-list',
  templateUrl: './customInfo-list.component.html',
  styleUrls: ['./customInfo-list.component.scss']
})
export class CustomInfoListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {   
    this.touch;
  }
 
  @Output() editCustomInfoEmmitter = new EventEmitter();
  @Output() deleteCustomInfoEmmitter = new EventEmitter();

  @Input() touch;

  editCustomInfo(CustomInfo: any){
    this.editCustomInfoEmmitter.emit(CustomInfo);
  }

  deleteCustomInfo(CustomInfo: any){
    this.deleteCustomInfoEmmitter.emit(CustomInfo);
  }

  // Presentation helpers (icon per custom-info type, author initials)
  noteIcon(typeName: any): string {
    const t = ((typeName || '') + '').toLowerCase();
    if (t.indexOf('email') !== -1) { return 'mail'; }
    if (t.indexOf('phone') !== -1 || t.indexOf('call') !== -1) { return 'call'; }
    if (t.indexOf('meeting') !== -1) { return 'groups'; }
    if (t.indexOf('note') !== -1) { return 'sticky_note_2'; }
    if (t.indexOf('log') !== -1) { return 'history'; }
    return 'info';
  }

  initials(first: any, last: any): string {
    const f = ((first || '') + '').trim();
    const l = ((last || '') + '').trim();
    const s = (f ? f[0] : '') + (l ? l[0] : '');
    return s ? s.toUpperCase() : '?';
  }


}
